import React from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';
import {
  pageState,
  withPageStateProvider,
} from 'common/libs/PageState/pageState';
import busAgentAutoCompleteSchema from '../../shared/schemas/busAgentAutoCompleteSchema';
import BusAgentAutoComplete from '../components/BusAgentAutoComplete/BusAgentAutoComplete';
import fetchAutoCompleteAgent from '../actions/fetchAutoCompleteAgent';
import { denormalize } from 'normalizr';
import setAgentId from '../actions/setAgentId';

const mapStateToProps = state => ({
  agents: denormalize(
    state.bus.autoCompleteAgent,
    [busAgentAutoCompleteSchema],
    state.entities
  ),
});
const mapDispatchToProps = dispatch => ({
  fetchAutoCompleteAgent: query => dispatch(fetchAutoCompleteAgent(query)),
  setAgentId: agentId => dispatch(setAgentId(agentId)),
});

@connect(
  mapStateToProps,
  mapDispatchToProps
)
@withPageStateProvider()
@pageState()
class BusAgentAutoCompleteContainer extends React.Component {
  state = {
    keyword: '',
  };

  componentDidMount() {
    this.debouncedFetchAutoComplete();
  }

  @pageState({ error: 'snackbar.error' })
  fetchAutoComplete = async () => {
    await this.props.fetchAutoCompleteAgent(this.state.keyword);
  };

  debouncedFetchAutoComplete = debounce(this.fetchAutoComplete, 300);
  handleChangeKeyword = keyword => {
    this.setState({ keyword }, () => {
      this.debouncedFetchAutoComplete(keyword);
    });
  };

  handleItemPressed = async item => {
    const { code: agentId } = item;
    await this.props.setAgentId(agentId);
    this.props.onClose({ agentId });
  };

  render() {
    const sections = [
      {
        label: 'Nama Agen',
        data: this.props.agents.map(({ agentId, agentUserName }) => ({
          label: agentUserName,
          code: agentId,
        })),
      },
    ];

    return (
      <BusAgentAutoComplete
        {...this.props}
        sections={sections}
        keyword={this.state.keyword || ''}
        onChangeKeyword={this.handleChangeKeyword}
        onItemPressed={this.handleItemPressed}
      />
    );
  }
}

export default BusAgentAutoCompleteContainer;
